<template>
    <div class="fillform" v-loading.fullscreen.lock="loading" v-loading="loading">
   <p>苏 格 兰 学 院 学 每 月 工 作 汇 报 表</p>
        <div class="mainHeader">
  
         <div class="oneline">
            <el-form :inline="true"  :model="formInline" class="demo-form-inline">
            <el-form-item label="授课教师">
                <el-input v-model="formInline.teacher" readonly placeholder="授课教师"></el-input>
            </el-form-item>
            <el-form-item label="所在部门">
                <el-input v-model="formInline.teacherUnit"  readonlyplaceholder="教师所在单位"></el-input>
            </el-form-item>
                    <el-form-item label="教师职称">
                <el-input v-model="formInline.teacherTitle" readonly placeholder="教师职称"></el-input>
            </el-form-item>
            <!-- <el-form-item label="年龄层次">
                <el-select v-model="formInline.teacherAgeLevel" placeholder="年龄层次">
                <el-option label="老(>55)" value="55"></el-option>
                <el-option label="中(35-55)" value="35"></el-option>
                <el-option label="青(20-35)" value="20"></el-option>
                </el-select>
            </el-form-item> -->
            
            </el-form>
        </div>
    
  
        
    
  
  
  
  
      </div>
  

       <div class="assessformTeacher" v-loading="loading">
  
          
            
               <div class="midform_T">
                    <div style="padding-top:0px;padding-left:40px;padding-bottom:1px">
                    <p>1</p></div>
                    <div style="padding-top:10px;padding-left:40px">
                    <p>2</p></div>
                     <div style="padding-top:10px;padding-left:40px">
                    <p>3</p></div>
                       <div style="padding-top:10px;padding-left:40px">
                      <p>4</p></div>
                      <div style="padding-top:10px;padding-left:40px">
                      <p>5</p></div>
                  <div style="padding-top:10px;padding-left:40px">
                      <p>6</p></div>
                   <div style="padding-top:10px;padding-left:40px">
                      <p>7</p></div>
                     <div style="padding-top:10px;padding-left:40px">
                      <p>8</p></div>
               <div style="padding-top:10px;padding-left:40px">
                      <p>9</p></div>
                <div style="padding-top:10px;padding-left:40px">
                      <p>10</p></div>
                    <div style="padding-top:10px;padding-left:40px">
                      <p>11</p></div>
                      <div style="padding-top:10px;padding-left:40px">
                      <p>12</p></div>
                    <div style="padding-top:10px;padding-left:40px">
                      <p>13</p></div>
  
               <div style="padding-top:10px;padding-left:40px">
                      <p>14</p></div>
                 <div style="padding-top:10px;padding-left:40px">
                      <p>15</p></div>
                      <div style="padding-top:10px;padding-left:40px">
                      <p>16</p></div>
               
               </div>
    
                
              <div class="Rightform_T">
                  <div class="oneline" v-loading="loading">
                    <el-form :inline="true" :model="formInline" readonly class="demo-form-inline">
                        <el-form-item label="超课时数">
                           
                        </el-form-item>
                         <el-form-item>                     <el-input v-model="formInline.over_class" type="number" readonly oninput="if(value.length>6)value=value.slice(0,6)" placeholder="规定课时数"></el-input>                </el-form-item>
                          <el-form-item>                     <el-input v-model="formInline.reality_class" readonly  type="number" oninput="if(value.length>6)value=value.slice(0,6)" placeholder="实际课时数"></el-input>                </el-form-item>
                    </el-form>
                    </div>
                 <div class="oneline">
                    <el-form :inline="true"  :model="formInline" class="demo-form-inline">
                        <el-form-item label="每周工作简报">
                           
                        </el-form-item>
                        <el-form-item>                     <el-input v-model="formInline.workBrief_times" readonly type="number" oninput="if(value.length>6)value=value.slice(0,6)" placeholder="本月提交周报（次数）"></el-input>                </el-form-item>
                          <el-form-item>                    
                            <el-tooltip class="item" effect="light" :disabled="formInline.comment2==null||formInline.comment2.length<10" :content="formInline.comment2" placement="top">
                <el-input v-model="formInline.comment2" readonly placeholder="补充说明（可选）"></el-input>
                           </el-tooltip>                                            </el-form-item>
                    </el-form>
                 
                    </div>
                  <div class="oneline">
                    <el-form :inline="true" :model="formInline" class="demo-form-inline">
                        <el-form-item label="节假日值班">
                          
                        </el-form-item>
                           <el-form-item>                     <el-input  type="number" readonly oninput="if(value.length>7)value=value.slice(0,7)" v-model="formInline.holidays_duty_day_hour" placeholder="白天值班（小时数）"></el-input>                </el-form-item>
                              <el-form-item>                     <el-input v-model="formInline.holidays_duty_night_hour"  type="number" oninput="if(value.length>7)value=value.slice(0,7)" placeholder="晚上值班（小时数）"></el-input>                </el-form-item>
                          <el-form-item>                     <el-input v-model="formInline.holidays_duty_points_times" readonly type="number" oninput="if(value.length>7)value=value.slice(0,7)" placeholder="未到岗次数"></el-input>                </el-form-item>
                    </el-form>
                    </div>
                       <!-- <el-divider></el-divider> -->
                 <div class="oneline">
                    <el-form :inline="true"  :model="formInline" class="demo-form-inline">
                        <el-form-item label="晚自习值班">
                         
                        </el-form-item>
                         <el-form-item>                     <el-input v-model="formInline.night_duty_times" readonly  type="number" oninput="if(value.length>7)value=value.slice(0,7)" placeholder="晚自习值班（次数）"></el-input>                </el-form-item>
                          <el-form-item>                      <el-tooltip class="item" effect="light" :disabled="formInline.comment4==null||formInline.comment4.length<10" :content="formInline.comment4" placement="top">
                <el-input v-model="formInline.comment4" readonly placeholder="补充说明（可选）"></el-input>
                           </el-tooltip>                    </el-form-item>
                    </el-form>
                   
                    </div>
                 <div class="oneline">
                    <el-form :inline="true" :model="formInline" class="demo-form-inline">
                        <el-form-item label="课外赛项辅导">
                           
                        </el-form-item>
                         <el-form-item>                     <el-input v-model="formInline.instruction_after_class_time" readonly type="number" oninput="if(value.length>7)value=value.slice(0,7)" placeholder="赛项辅导（小时数）"></el-input>                </el-form-item>
                          <el-form-item>                         <el-tooltip class="item" effect="light" :disabled="formInline.comment5==null||formInline.comment5.length<10" :content="formInline.comment5" placement="top">
                              <el-input v-model="formInline.comment5" readonly placeholder="补充说明（可选）"></el-input>
                           </el-tooltip>                    </el-form-item>
                    </el-form>
     
                    </div>
                 <div class="oneline">
                    <el-form :inline="true" :model="formInline" class="demo-form-inline">
                        <el-form-item label="第二课堂活动">
                          
                        </el-form-item>
                         <el-form-item>                     <el-input v-model="formInline.class_room_activities_time" readonly  type="number" oninput="if(value.length>7)value=value.slice(0,7)" placeholder="参加第二课堂活动（小时数）"></el-input>                </el-form-item>
                          <el-form-item>                        <el-tooltip class="item" effect="light" :disabled="formInline.comment6==null||formInline.comment6.length<10" :content="formInline.comment6" placement="top">
                <el-input v-model="formInline.comment6" readonly placeholder="补充说明（可选）"></el-input>
                           </el-tooltip>                    </el-form-item>
                    </el-form>
                    </div>
                 <div class="oneline">
                    <el-form :inline="true" :model="formInline" class="demo-form-inline">
                        <el-form-item label="文稿撰写（图文）">
           
                        </el-form-item>
                         <el-form-item>                     <el-input v-model="formInline.manuscript_writing_common_number" readonly  type="number" oninput="if(value.length>9)value=value.slice(0,9)" placeholder="中文文稿（字数）"></el-input>                </el-form-item>
                           <el-form-item>                     <el-input v-model="formInline.manuscript_writing_both_number" readonly placeholder="双语文稿（中文字数）" type="number" oninput="if(value.length>9)value=value.slice(0,9)"></el-input>                </el-form-item>
                             <el-form-item>                     <el-input v-model="formInline.manuscript_writing_nice_times" readonly placeholder="每月最佳推文（篇数）" type="number" oninput="if(value.length>8)value=value.slice(0,8)"></el-input>                </el-form-item>
                          <!-- <el-form-item>                     <el-input v-model="formInline.comment7" placeholder="补充说明（可选）"></el-input>                </el-form-item> -->
                    </el-form>
                    </div>
  
                                    <!-- <el-divider></el-divider> -->
                   
                 <div class="oneline">
                    <el-form :inline="true"  :model="formInline" class="demo-form-inline">
                        <el-form-item label="文稿翻译">
                          
                        </el-form-item>
                         <el-form-item>                     <el-input v-model="formInline.manuscript_translation_number" readonly type="number" oninput="if(value.length>10)value=value.slice(0,10)" placeholder="中文文稿（字数）"></el-input>                </el-form-item>
                          <el-form-item>                             <el-tooltip class="item" effect="light" :disabled="formInline.comment7==null||formInline.comment7.length<10" :content="formInline.comment7" placement="top">
                <el-input v-model="formInline.comment7" readonly placeholder="补充说明（可选）"></el-input>                        
                 </el-tooltip>                    </el-form-item>
                    </el-form>
                
                    </div>
                 <div class="oneline">
                    <el-form :inline="true" :model="formInline" class="demo-form-inline">
                        <el-form-item label="专题讲座">
                        
                        </el-form-item>
                         <el-form-item>                     <el-input v-model="formInline.seminar_times" readonly type="number" oninput="if(value.length>7)value=value.slice(0,7)" placeholder="专题讲座（场次）"></el-input>                </el-form-item>
                        <el-form-item>                         <el-tooltip class="item" effect="light" :disabled="formInline.comment8==null||formInline.comment8.length<10" :content="formInline.comment8" placement="top">
                <el-input v-model="formInline.comment8" readonly placeholder="补充说明（可选）"></el-input>
                 </el-tooltip>                   </el-form-item>
                    </el-form>
                    </div>
               <div class="oneline">
                    <el-form :inline="true" :model="formInline" class="demo-form-inline">
                        <el-form-item label="听评课记录">
                     
                     </el-form-item>
                      <el-form-item>                     <el-input v-model="formInline.listen_class_times" readonly type="number" oninput="if(value.length>5)value=value.slice(0,5)" placeholder="听评课并记录（次数）"></el-input>                </el-form-item>
                       <el-form-item>                        <el-tooltip class="item" effect="light" :disabled="formInline.comment9==null||formInline.comment9.length<10" :content="formInline.comment9" placement="top">
                <el-input v-model="formInline.comment9" readonly placeholder="补充说明（可选）"></el-input>
                 </el-tooltip>                 </el-form-item>
            
                    
                    </el-form>
                      <!-- <el-divider></el-divider> -->
             </div>
  
                          <div class="oneline">
                    <el-form :inline="true" :model="formInline" class="demo-form-inline">
                        <el-form-item label="教研活动">
                      
                     </el-form-item>
                     <el-form-item>                     <el-input v-model="formInline.attending_meetings_times" readonly type="number" oninput="if(value.length>5)value=value.slice(0,5)" placeholder="教研活动（参加次数）"></el-input>                </el-form-item>
                       <el-form-item>                      <el-tooltip class="item" effect="light" :disabled="formInline.comment10==null||formInline.comment10.length<10" :content="formInline.comment10" placement="top">
                <el-input v-model="formInline.comment10" readonly placeholder="补充说明（可选）"></el-input>
                 </el-tooltip>                 </el-form-item>
                    <!-- <el-form-item>
                      <el-tooltip class="item" effect="light" :disabled="formInline.comment11.length<10" :content="formInline.comment11" placement="top">
                <el-input v-model="formInline.comment11" readonly placeholder="补充说明（可选）"></el-input>
                 </el-tooltip>  
                    </el-form-item> -->
                    
                    </el-form>
                    
             </div>
  
                          <div class="oneline">
                    <el-form :inline="true" :model="formInline" class="demo-form-inline" >
                        <el-form-item label="应邀代表学院参加社会活动">
                     
                     </el-form-item>
                       <el-form-item>                     <el-input v-model="formInline.public_activity_common_times" readonly type="number" oninput="if(value.length>5)value=value.slice(0,5)" placeholder="应邀参加（次数）"></el-input>                </el-form-item>
                       <el-form-item>                     <el-input v-model="formInline.public_activity_nice_times" readonly type="number" oninput="if(value.length>5)value=value.slice(0,5)" placeholder="应邀参加并发言（次数）"></el-input>                </el-form-item>
                    <el-form-item>
                      <el-tooltip class="item" effect="light" :disabled="formInline.comment11==null||formInline.comment11.length<10" :content="formInline.comment11" placement="top">
                <el-input v-model="formInline.comment11" readonly placeholder="补充说明（可选）"></el-input>
                 </el-tooltip>  
                    </el-form-item>
                    
                    </el-form>
                      <!-- <el-divider></el-divider> -->
             </div>
  
                         <div class="oneline">
                    <el-form :inline="true" :model="formInline" class="demo-form-inline">
                        <el-form-item label="课程外监考">
                         
                        </el-form-item>
                          <el-form-item>                     <el-input v-model="formInline.invigilate_times" readonly type="number" oninput="if(value.length>5)value=value.slice(0,5)" placeholder="课程外监考（次数）"></el-input>                </el-form-item>
                        <el-form-item>                    
              <el-tooltip class="item" effect="light" :disabled="formInline.comment12==null||formInline.comment12.length<10" :content="formInline.comment12" placement="top">
                <el-input v-model="formInline.comment12" readonly placeholder="补充说明（可选）"></el-input>
                 </el-tooltip>                </el-form-item>
                    </el-form>
                    </div>
    
                           <div class="oneline">
                    <el-form :inline="true" :model="formInline" class="demo-form-inline">
                        <el-form-item label="班主任">
                          
                        </el-form-item>
                          <el-form-item>                     <el-input v-model="formInline.teacher_duty_success_times" readonly placeholder="规定职责（项数）"></el-input>                </el-form-item>
                        <el-form-item>                     <el-input v-model="formInline.teacher_duty_faile_times" readonly placeholder="实际完成规定职责（项数）"></el-input>                </el-form-item>
                    </el-form>
                    </div>
  
                                           <div class="oneline">
                    <el-form :inline="true" :model="formInline" class="demo-form-inline">
                        <el-form-item label="指导学生大创项目">
                           
                        </el-form-item>
                          <el-form-item>                     <el-input v-model="formInline.occupational_guidance_times" readonly type="number" oninput="if(value.length>7)value=value.slice(0,7)" placeholder="大创活动（次数）"></el-input>                </el-form-item>
                        <el-form-item>                            <el-tooltip class="item" effect="light" :disabled="formInline.comment13==null||formInline.comment13.length<10" :content="formInline.comment13" placement="top">
                <el-input v-model="formInline.comment13" readonly placeholder="活动名称及获奖情况）"></el-input>
                 </el-tooltip>               </el-form-item>
                         <el-form-item>                        <el-tooltip class="item" effect="light" :disabled="formInline.comment14==null||formInline.comment14.length<10" :content="formInline.comment14" placement="top">
                <el-input v-model="formInline.comment14" readonly placeholder="补充说明（可选）"></el-input>
              </el-tooltip>             </el-form-item>
                    </el-form>
                    </div>
                    
                    <div class="oneline">
                  <el-form :inline="true" :model="formInline" class="demo-form-inline">
                      <el-form-item label="自选补充内容">
                         
                      </el-form-item>
                        <el-form-item>                     <el-input v-model="formInline.teacher_additional_score" readonly type="number" oninput="if(value.length>7)value=value.slice(0,7)" placeholder="补充内容（分值）"></el-input>                </el-form-item>
                      <el-form-item>                         <el-tooltip class="item" effect="light" :disabled="formInline.teacher_additional_comment==null||formInline.teacher_additional_comment.length<10" :content="formInline.teacher_additional_comment" placement="top">
                <el-input v-model="formInline.teacher_additional_comment" readonly
                placeholder="补充文字说明（必须）"></el-input>               
                </el-tooltip>                  </el-form-item>
                       <el-form-item>                       <el-tooltip class="item" effect="light" :disabled="formInline.teacher_additional_comment2==null||formInline.teacher_additional_comment2.length<10"  :content="formInline.teacher_additional_comment2" placement="top">
                <el-input v-model="formInline.teacher_additional_comment2" readonly
                placeholder="其它补充说明（可选）"></el-input>         
                </el-tooltip>                </el-form-item>
                  </el-form>
             </div>
          </div> 
        </div>
    
       
    
        <div class="metainfoFeedback" v-loading="loading">
        <el-form>
             <el-form-item label="情况说明及建议">
                 
                    <el-input   type="textarea"  style="width:1100px" readonly  :rows="3"   placeholder="请输入情况说明及建议（如需要）"   v-model="formInline.comment15"> </el-input>
            </el-form-item>
       </el-form>
             <div v-if="fileList.length>0" >
              <div v-for="(file,index) in fileList" :key="index">
                文件：<span @click="downfile(file)">{{file.old_name}}</span>
              </div>
             </div>
            
       </div>

        
    
      <el-dialog
    :visible.sync="dialogVisible"
    width="90%"
   >
  <el-button type=" primary" @click="dialogVisible=false">取消</el-button>
  </el-dialog>
    </div>
    
    
    </template>
    
    <script>
    export default {
      created(){
        
      },
    data() {
          return {
           dialogVisible:false,
           loading:false,
           notifyPromise:Promise.resolve(),

        }
  
  },
  props:['formInline','fileList']
    ,
  methods:{
    downfile(data){
      console.log(data)
      const formData = new FormData()
      formData.append('filePath', data.filePath)
      this.axios({
            url: "/file/downFile",   //后端地址
            method: "post",
            data:formData, //请求参数
            headers: {  
            'Access-Control-Allow-origin': '*', 'Content-Type': 'application/json; charset=UTF-8',
            },
            // contenType:'application/json',
            responseType: "blob"
          })
            .then(res => {
              console.log(res.data)
          const blob = new Blob([res.data], { type: 'xlsx' });
          const fileName = data.old_name; 
            const elink = document.createElement("a");
            elink.download = fileName;
            elink.style.display = "none";
            elink.href = URL.createObjectURL(blob);
            document.body.appendChild(elink);
            elink.click();
            URL.revokeObjectURL(elink.href); // 释放URL 对象
            document.body.removeChild(elink); 
            this.selectData=false
      
            })
  }
  }

}
    </script>
    
  <style scoped>
    
    .fillform{
  
  width:100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  border: 1px;
  padding-top: 30px;
}
.oneline{
  display: flex;
  flex-direction: column;
  /* height:100px; */
}
.singleinput{
  width:200px;
  height:20px ;
  margin-top: 15px;
  margin-left: 45px;
}

.multiinput{
  width:800px;
  height:80px ;
    margin-top: 15px;
  margin-left: 35px;
}
.metainfo
{
  width:100%;
  height: 100px;
  display: flex;
  border: 2px;
  flex-direction: column;


}
.metainfo1
{
  width:400px;
  height: 45px;
  display: flex;
  border: 1px;

}
.leftform_T{
  width:120px;
  height:980px;
    padding:10px;
  background-color:rgb(185, 212, 203);
  /* text-align:justify;
  vertical-align:middle; */
}
.leftform_S{
  width:270px;
  height:250px;
   padding:10px;
   padding-right:30px;
  background-color:rgb(202, 230, 219);
}

.leftform_All{
    width:270px;
  height:40px;
   padding:10px;
   padding-right:30px;
  background-color:rgb(107, 146, 130);
}
.midform_T{ width:150px; height:980px;; padding:10px; font-size:16px; background-color:rgba(153, 194, 197, 0.418); }
.Rightform_T{
  width: 930px!important;
  height:980px;
  padding:10px;
  background-color:rgba(186, 230, 233, 0.418);
}
.Rightform_S{
  width:930px;
  height:250px;;
  padding:10px;
  background-color:rgba(186, 230, 233, 0.618);
}
.Rightform_All{
  width:980px;
  height:40px;;
  padding:10px;
  background-color:rgba(128, 161, 163, 0.418);
}
.midform_S{
 width:150px;
  height:400px;;
  padding:10px;
  background-color:rgba(153, 194, 197, 0.418);
}
.eachquestionform{
  width: 40%;
  height:40%;
  display: flex;
  flex-direction: column;
}
.assessformTeacher
{
  display: flex;
  flex-direction: row;
  width: 100%;
  padding-top:0px;

  
}
.assessformstudent
{
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 40%;


  
}
.textvert{
  padding-top: 200px;
}
.metainfoFeedback
{
  width:100%;
  height: 120px;
  display: flex;
   flex-direction: column;
  border: 1px;
  margin-top:15px;
}

.uploadAttched
{
  width:100%;
  height: 80px;
  display: flex;
   flex-direction: column;
  border: 1px;
  margin-top:10px;
}
.actionButton{

  display: flex;
  padding-left:400px;
  padding-bottom: 20px;
  padding-top: 20px;
  
}

.actionButton2{

display: flex;
padding-left:400px;
padding-bottom: 20px;
padding-top: 150px;

}


.item .el-form-item__label{
      color: #aaaa33;
  }
.label-content .el-form-item__content{
      font-size: 20px;
      color: #aaaa33;
  }
el-form-item >>>.el-form-item__label{
      color: #aaaa33;
  }
.label-content .el-form-item__content{
      font-size: 20px;
      color: #aaaa33;
  }

.mainHeader{
    background-color: rgb(235, 226, 228);
    padding-top: 30px; 
}
    </style>


// WEBPACK FOOTER //
// src/components/work/teacher/KpiDemo.vue